import { BaseModel, fillOwnProperties, registerModel } from '~/shared/model'
import { isUnknownObject } from '~/shared/utils/guards'

export interface UniversityStream {
  id: number
  name: string
  image: string
  government_code: string
  education_level?: string
  created_at: string
  updated_at: string
  is_published: number
  description?: unknown
  page_id: number
  pivot?: { univer_id: number; stream_id: number }
  show_limit?: number | null
}

export interface UniversityNumbers {
  name: string
  value: string | number
}

export default class University extends BaseModel {
  static override constructorName = 'University'

  id: number = 0
  slug: string = ''
  is_published: number = 0
  name: string = ''
  logo: string = ''
  image: string = ''
  description: string = ''
  phone: string = ''
  link: string = ''
  budget_avg_score: string | number = ''
  commerce_avg_score: string | number = ''
  budget_places_number: number = 0
  budget_distant_places_number: number = 0
  foundation_year: string = ''
  region: string = ''
  city: string = ''
  email: string = ''
  status: string = ''
  short_name: string = ''
  address: string = ''
  teachers_number: number = 0
  students_number: number = 0
  bakalavr_programs_number: number = 0
  magistr_programs_number: number = 0
  aspirant_programs_number: number = 0
  slider_image: string = ''
  streams: UniversityStream[] = []
  created_at: string = ''
  updated_at: string = ''

  constructor(data?: unknown) {
    super(data)
    if (isUnknownObject(data)) {
      fillOwnProperties(this, data)
    }
  }
}

registerModel(University)
